import type { ReceiptTemplate } from '../schema';

export const diorTemplate: ReceiptTemplate = {
  id: 'dior',
  name: 'Dior Receipt',
  brand: 'DIOR',
  description: 'Luxury fashion house receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'dior-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/dior.png',
        logoData: '',
        logoWidth: 120,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          '1200 Dark Avenue',
          'Monsterville, CA 94608',
          'Tel: (510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'dior-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Transaction: 384719\nDate: 01/04/2026  Time: 16:21:33\nStore: 0127  Register: 01\nSales Advisor: MIKE W.',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'dior-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'dior-item-1', name: 'Lady Dior Medium Bag', quantity: '1', price: '5900.00'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'dior-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'dior-subtotal', label: 'Subtotal', value: '5,900.00', isBold: false, isLarge: false },
          { id: 'dior-tax', label: 'Tax', value: '523.63', isBold: false, isLarge: false },
          { id: 'dior-total', label: 'TOTAL', value: '6,423.63', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'dior-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'dior-card', label: 'VISA', value: '************4144' },
          { id: 'dior-auth', label: 'Auth Code', value: '917482' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'dior-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: 'DR384719012726',
        showValue: true,
        width: 1.5,
        height: 45,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'dior-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Thank you for visiting Dior.\nExchanges within 30 days with receipt.',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

